export const ROLE_HIERARCHY = {
  Admin: 4,
  HR: 3,
  Manager: 2,
  Employee: 1,
};

export const getDefaultRoute = (role) => {
  switch (role) {
    case 'Employee':
      return '/my-portal';
    case 'Manager':
      return '/attendance';
    case 'HR':
      return '/employees';
    case 'Admin':
      return '/dashboard';
    default:
      return '/attendance';
  }
};

export const hasRoleLevel = (userRole, requiredRole) => {
  if (!userRole || !requiredRole) return false;
  const userLevel = ROLE_HIERARCHY[userRole] ?? 0;
  const requiredLevel = ROLE_HIERARCHY[requiredRole] ?? 0;
  return userLevel >= requiredLevel;
};

export const canManageHolidays = (role) => role === 'Admin' || role === 'HR';

export const canShowHoliday = (user) => user?.showHoliday !== false;

export const canImportAttendance = (role) => role === 'Admin' || role === 'HR';

export const canViewAllLeaveBalances = (role) =>
  role === 'Admin' || role === 'HR' || role === 'Manager';

export const canExportLeaves = (role) => role === 'Admin' || role === 'Manager';

export const canEditPayroll = (role) => role === 'Admin' || role === 'Manager';

export const canEditAdvances = (role) => role === 'Admin' || role === 'Manager';

export const canApproveAdvances = (role) => role === 'Admin';

export const canRequestBonus = (role) => role === 'Admin' || role === 'Manager';

export const canApproveBonus = (role) => role === 'Admin';

export const canManagePolicies = (role) => role === 'Admin' || role === 'HR';

export const canDeletePolicies = (role) => role === 'Admin';
